import * as React from "react";
const SvgTextItalicLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.933 20a1 1 0 1 1 0-2h1.362l4.286-12h-1.58a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2h-1.297l-4.286 12h1.599a1 1 0 1 1 0 2z", clipRule: "evenodd" }));
export default SvgTextItalicLine;
